import type {CommonProps} from './types';

const UsersSmall = ({
  color = 'currentColor',
  size = 14,
  ...rest
}: CommonProps) => (
  <svg
    aria-hidden="true"
    width={size}
    height={size}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M1 11a4.1 4.1 0 018.18 0M2.6 3.7v.47c.02.7-.17 1.39-.53 1.98M7.58 3.7l.01.47c-.02.7.16 1.39.52 1.98M2.6 3.7a3.32 3.32 0 002.5-1.15A3.32 3.32 0 007.57 3.7"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.6 3.5a2.5 2.5 0 105 0 2.5 2.5 0 00-5 0v0zM9.64 7.01a4.1 4.1 0 015 3.99M9.18 1.4a2.5 2.5 0 11.46 4.43"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.04 3.7v.47c-.02.7.16 1.39.53 1.98M9.18 3.5c.53-.2 1-.53 1.37-.95a3.32 3.32 0 002.49 1.15"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default UsersSmall;
